import { ACTIONS, CONFIGS } from '@/data/state-modules';

export default {
  computed: {
    defaultConfig() {
      const stateModule = this.$store.getters.currentStateModule;
      return CONFIGS[stateModule];
    },
  },
  methods: {
    dispatchToStateModule(type, ...args) {
      const stateModule = this.$store.getters.currentStateModule;

      return this.$store.dispatch(ACTIONS[stateModule][type], ...args);
    },
  },
};
